import oppRegService from '@/services/oppreg.service.js'
import awsAcctService from '@/services/awsacct.service.js'
// import router from '@/router/routes/user/index.js'
import contactInfoService from '@/services/contactinfo.service.js'
import ChangeLogService from '../../../../../services/changelog.service'
import ApiService from '../../../../../services/api.service'

export default {
  // REQUEST AWS
  getAllCustomers: (context) => {
    awsAcctService.getAllCustomers( res => {
      context.commit('loadCustomers', res)
    })
  },
 
  addCustomer: (context, data) => {
    awsAcctService.addCustomer ( data, (res,error) =>{
      if(error) {
      } else {
        let custObj = {
          Customer_Id: res.id,
          Customer_Alias: data.Customer_Alias,
          Customer_Name: data.Customer_Name,
          Customer_Region: data.Customer_Region,
          Cust_Region: data.Customer_Name+' - '+data.Customer_Region
        }
        context.commit('updateCustomers', custObj)
      }

    })
  },
  updateCustomer: async (context, data) => {
    awsAcctService.updateCustomer(data, (res, err) => {
      if (err) {} else {
        console.log('message: '+ res)
      }
    })
  },
  getOppregProject: (context, SFDC_id) => {
    context.commit('setWorkloadLoading', true)
    oppRegService.getWorkloadsBySalesForceId(SFDC_id, res => {
      context.commit('loadWorkloadByOppId', res)
      context.commit('setWorkloadLoading', false)
    })
  },
 
  checkEmailAvailability: (context, email) => {
    context.commit('setloadingEmailData', true)
    contactInfoService.getByEmail(email, contact => {
      context.commit('loadEmail', [contact])
      context.commit('setloadingEmailData', false)
    })
  },
  createContact: (context, workload) => {
    awsAcctService.createWorkloadContactInfo(workload, res => {
    })
  },
  updateContactInfo: (context, contact) => {
    context.commit('savingContact', true)
    awsAcctService.updateWorkloadContactInfo(contact, id => {
      context.commit('updateOnboardingContactId', id)
      context.commit('savingContact', false)
      context.commit('setRegistrationStep', 'validation')
    })
  },

  validateOppRegId: (context, oppregId) => {
    context.commit('setOppRegIdExistLoading', true)
    awsAcctService.validateOppRegId(oppregId, res =>{
      if(res.length > 0){
        context.commit('setOppRegIdExistLoading', false)
        context.commit('setOppRegIdAvailability', { type: 'success', message: 'OppReg ID does exist'} )
        context.commit('setWorkloadsByOppRegId', res)
      } else {
        context.commit('setOppRegIdExistingLoading', false)
        context.commit('setOppRegIdAvailability', { type: 'error' , message: 'OppReg ID does not exist'})
      }
      
    })
  },

  generateId: (context, type) => {
    context.commit('setGeneratingOppId', true)
    oppRegService.generateId(type, (res, err) => {
      if (err) {

      } else {
        context.commit('setInternalOpportunityId', res.dxcint_counter)
      }
      context.commit('setGeneratingOppId', false)
    })
  },

  submitInternalWorkload: async (context, workload) => {
    context.commit('setLoader', { loading: true, text: 'Please wait while the page is loading...' }, { root: true })

    await contactInfoService.getByEmail(workload.payload.contact.Contact_Email, (contact, err) => {
      if (err) {
        console.log('contact created')
      } else {
        workload.payload.contact.Contact_Id = contact.Id
        contactInfoService.update({ ...workload.payload.contact, Id: contact.Id })
      }
    })
    // if we still don't have a contact id, create new
    if (!workload.payload.contact.Contact_Id) {
      await contactInfoService.create(workload.payload.contact, (id, err) => {
        if (err) {
        } else {
          workload.payload.contact.Contact_Id = id
        }
      })
    }

    context.commit('updateInternalOnboardingContact', workload.payload.contact.Contact_Id)
    // set OppReg_Req_Date to be today's date
    workload.payload.fields.OppReg_Req_Date = window.moment().format('YYYY-MM-DD')
    // set requestor
    workload.payload.oppFields.requestor.Requestor_Id = vm.$store.state.currentUser.requestor_id
    workload.payload.fields.Requestor_Id = vm.$store.state.currentUser.requestor_id
    workload.payload.fields.Contact_Id = workload.payload.contact.Contact_Id
    workload.payload.fields.Workload_type = 'PPA'
    
    await oppRegService.oppSubmit(workload.payload, (res, err) => {
      if (err) {
        context.commit('setSnackbar',
          {
            show: true,
            type: 'error',
            timeout: 10000,
            message: 'An error has occured while saving the registration. Please contact administrator'
          },
          { root: true }
        )
      }
    })

    await oppRegService.workLoadSubmit(workload.payload.fields, (id, err) => {
      if (err) {
        context.commit('setSnackbar',
          {
            show: true,
            type: 'error',
            timeout: 10000,
            message: 'An error has occured while saving the registration. Please contact administrator'
          },
          { root: true }
        )
      } else {
        context.commit('setChangeLogRecord', { id: id, changeTo: workload.payload.fields }, { root: true })
        ChangeLogService.create(context.rootState.logRecord)
        context.commit('setLoader', { loading: false }, { root: true })
        context.commit('updateInternalRegistrationProjectId', id)
        context.commit('setInternalRegistrationStep','validation')
      }
    })
    
  },

  onOppIdValidate: (context, oppDetails) => {
    console.log('onOppIdValidate')
    context.commit('setOppIdExistsLoading', { awsType: oppDetails.awsType, loading: true })
    awsAcctService.validateOppRegId(oppDetails.oppId, res => {
      if (res.length > 0) {
        if (res[0]['Workload_type'] ==='NONDXC') {
          context.commit('setOppIdExistsLoading', { awsType: oppDetails.awsType, loading: false })
          context.commit('setOppRegIdAvailabilityMessage', { awsType: oppDetails.awsType,type:'error', message: 'Workload type cannot be NONDXC. Please complete the Update Discount Qualification section in Galaxy Opportunity Registration, left hand column.' })
        } else if (res[0]['Workload_type'] ==='DONTKNOW') {
          context.commit('setOppIdExistsLoading', { awsType: oppDetails.awsType, loading: false })
          context.commit('setOppRegIdAvailabilityMessage', { awsType: oppDetails.awsType,type:'error', message: 'Workload type cannot be DONTKNOW. Please complete the Update Discount Qualification section in Galaxy Opportunity Registration, left hand column.' })
        } else {
          context.commit('setOppIdExistsLoading', { awsType: oppDetails.awsType, loading: false })
          context.commit('setOppRegIdAvailabilityMessage', { awsType: oppDetails.awsType,type:'success', message: 'Opportunity Registration ID does exist' })
          context.commit('setAllWorkloadsByOppregId', { awsType: oppDetails.awsType, workloads: res} )
        }
        
      } else {
        context.commit('setOppIdExistsLoading',{ awsType: oppDetails.awsType, loading: false })
        context.commit('setOppRegIdAvailabilityMessage', { awsType: oppDetails.awsType,type:'error', message: 'Opportunity Registration ID does exist' })
      }
    })
  },

 // New Client Questionnaire Update
 updateOnboarding: (context, onboarding) => {
   console.log('--------- onboarding ----------')
   console.log(onboarding)
   console.log('-------------------------------')
   awsAcctService.updateOnboardingMpId(onboarding,(res,err) => {
     if(err){
       
     } else {
       console.log('---------- updateOnboardingMpId Result ----------------')
       console.log(res)
       console.log('-------------------------------------------------------')
       let masterId = res[0].Master_Id
       console.log('masterId: ' , masterId)
       context.commit('updateOnboardingFields', { fields: onboarding, mpid: masterId})
     }
   })
 }, 


  // ACTIONS FOR QUESTIONNAIRE
  getAccountName: (context, workload) => {
    awsAcctService.getOnboardingAcctName(workload, res => {
    })
  },
  saveQuestionnaire: (context, workload) => {
    awsAcctService.submitAWSQuestionnaire(workload, res => {
    })
  },
  
  getRestrictedRegions: (context, regions) => {
    awsAcctService.getRestrictedRegions(regions,(res, err) => {
      if(err){
      } else {
        context.commit('setRestrictedRegions',res)
      }
    })
  },

  getAllOnboardingRecords:(context) => {
    awsAcctService.getAllOnboardingRequests(res => {
      console.log('------------ load all onboarding records ---------')
      console.log(res)
      console.log('--------------------------------------------------')
      context.commit('setOnboardingRecords', res )
    })
  },

  createOnboardingAccount: (context, onboarding) => {
    console.log('-------- createOnboardingAccount ----------')
    console.log(onboarding)
    console.log('-------------------------------------------')
    context.commit('onboardingAccount', true)
    context.commit('savingForLater', true)
    awsAcctService.createOnboardingAccount(onboarding, (res, err) => {
      if (err) {
        // throw an error
      } else {
        context.commit('onboardingAccount', false)
        context.commit('savingForLater', false)
        // add reset
        context.commit('setSnackbar',
          {
            show: true,
            type: 'success',
            timeout: 50000,
            message: `Successfully created onboarding record`,
            buttons: false
          },
          { root: true }
        )

        setTimeout(function () {
          context.commit('clearAwsAccountListing')
          context.commit('clearNewAccount')
          context.commit('clearValidation')
          context.commit('clearOnboardingQuestionnaire')
          context.commit('clearAwsAccountContacts')

          // Existing Client
          context.commit('clearExistingAccount')
          context.commit('clearExistingAwsAcctValidation')
          context.commit('clearExistingAwsOnboarding')
          context.commit('clearExistingAwsOnboardingContacts')

          // Internal Client
          context.commit('clearInternalAccount')
          context.commit('clearInternalAwsAcctValidation')
          context.commit('clearInternalAwsOnboarding')
          context.commit('clearInternalAwsOnboardingContacts')

          vm.$router.push({ path: `/list-aws-account/view-my-requests` })

        }, 2000)
      }
    })
  },

  searchOpportunityId: async (context, sfdcId) => {
    if (!sfdcId) {
      context.commit('setSearchResponse', { error: true, message: 'Opportunity Id not yet registered' })
    } else {
      console.log('searchopportunity_id:', sfdcId)
      context.commit('setLoadingWorkloads', true)
      context.commit('setSearchResponse', { error: false, message: '' })
      let opp = await oppRegService.findOpportunityById(sfdcId)

      if (!opp) {
        context.commit('setSearchResponse', { error: true, message: 'Opportunity Id not yet registered' })
        context.commit('setLoadingWorkloads', false)
      } else {
        context.commit('setWorkloadRecord', { opportunityName: opp.SFDC_Oppty_Name })
        context.commit('setWorkloadCustName', { Tmp_Cust_Name: opp.Customer_Name})
        // context.commit('setWorkloadRecord', { opportunityName: oppResponse.data.OpportunityName })
        oppRegService.getWorkloadsByOppId(sfdcId, (res, err) => {
          if (err) {
            context.commit('setSearchResponse', { error: true, message: err.message })
          } else {
            context.commit('setWorkloads', res.workloads)
          }
          context.commit('setLoadingWorkloads', false)
        })
      }
    }
  },

  validateWbsCode: (context, code) => {
    context.commit('resetWbsValidation')
    context.commit('setWbsCodeValidating', true)
    awsAcctService.validateWbsCode(code, (res, err) => {
      if (err) {
        context.commit('setWbsValidationResponse', { valid: false, message: err.message })
      } else {
        if (res.valid && res.isbWbsCode) {
          if (res.isAuthorized) {
            context.commit('setSnackbar',
              {
                show: true,
                type: 'warning',
                timeout: 20000,
                message: 'You are authorized to use the WBS code and can proceed with your request.'
              },
              { root: true }
            )
            context.commit('setWbsValidationResponse', { valid: true, type: res.type, message: res.message })
          } else {
            context.commit('setSnackbar',
              {
                show: true,
                type: 'error',
                timeout: 50000,
                message: "You are not authorized to submit AWS account request for Insurance.  Please contact  Mannar, Raj <a style='color:#fff; text-decoration: underline' href='mailto:rkaliyurmann@dxc.com'>rkaliyurmann@dxc.com</a> or  R, Renjith <a style='color:#fff; text-decoration: underline' href='mailto:renjith.r@dxc.com'>renjith.r@dxc.com</a>  from Global Insurance AWS team with request details."
              },
              { root: true }
            )
            context.commit('setWbsValidationResponse', { valid: false, message: "You are not authorized to use the WBS code" })
          }
        } else {
          context.commit('setWbsValidationResponse', { valid: true, type: res.type, message: res.message })
        }
      }

      context.commit('setWbsCodeValidating', false)
    })
  },

  validateIwoCode: (context, code) => {
    context.commit('setIwoCodeValidating', true)
    awsAcctService.validateIwoCode(code, (res, err) => {
      if (err) {
        context.commit('setIwoValidationResponse', { valid: false, message: err.message })
      } else {
        context.commit('setIwoValidationResponse', { valid: true, message: res.message })
      }
      context.commit('setIwoCodeValidating', false)
    })
  },

  getCustomers: (context,awsType) => {
    console.log('awsType:: ', awsType)

    awsAcctService.checkCustomers(awsType, (res, err) => {
      if (err) {
      } else {
        if(awsType === 'existing'){
          context.commit('setCustomers', res)
        } 
        if(awsType === 'internal'){
          context.commit('setCustomersInternal', res)
          context.commit('setLoadingCustomers', false)
        }
      }
    })
  },
  getMPayers:(context, data) => {
    console.log('you are here mon...')
    awsAcctService.getAllMasterPayer((res,err)=>{
      if(err){
        
       } else {
          console.log('---------- GetMPayers -----------')
          console.log(res)
          console.log('---------------------------------')
          context.commit('setMasterPayers', res)
        }
    })

    },
  getAwsOnboarding: (context, custObj) => {
    console.log('------Action: getAwsOnboarding ------')
    console.log(custObj)
    console.log('-------------------------------------')
    context.commit('setAcctsLoading', true)
    awsAcctService.getAwsOnboarding(custObj.custId, (res, err) => {
      if (err) {
      } else {
        if(custObj.isAdditionalAcctSupport === 'Y'){
          context.commit('setAcctsLoading', false)
          context.commit('setCustomerOnboarding', res)
        } else {
          context.commit('setAcctsLoading', false)
          context.commit('setCustomerAgreement', res[0].Agreement)
        }
      }
    })
  },
  createOnboarding: (context, data) => {
    awsAcctService.createOnboarding(data, (res, err) => {
      if (err) {

      } else {
        context.commit('setOnboardingId', res)
      }
    })
  },
  validateWbsCodeExisting: (context, code) => {
    context.commit('resetWbsValidation')
    context.commit('setWbsCodeValidating', true)
    awsAcctService.validateWbsCode(code, (res, err) => {
      if (err) {
        context.commit('setWbsValidationResponse', { valid: false, message: err.message })
      } else {
        context.commit('setWbsValidationResponse', { valid: true, type: res.type, message: res.message })
      }
      context.commit('setWbsCodeValidating', false)
    })
  },

  validateIwoCodeExisting: (context, code) => {
    context.commit('setIwoCodeValidating', true)
    awsAcctService.validateIwoCode(code, (res, err) => {
      if (err) {
        context.commit('setIwoValidationResponse', { valid: false, message: err.message })
      } else {
        context.commit('setIwoValidationResponse', { valid: true, message: res.message })
      }
      context.commit('setIwoCodeValidating', false)
    })
  },

  uploadToS3AndAddFileNameToPayload: async (context, file) => {
    context.commit('setLoader', { loading: true, text: 'Please wait while we upload your file...' }, { root: true })
    let res = await awsAcctService.uploadToS3(file, 'AWS_ONBOARDING');
    context.commit('addS3FileName', file.filename);
    context.commit('addS3FileNameToAccountRecord', file.filename)
    context.commit('setLoader', { loading: false}, { root: true });
    return res;
  },

  sendEmailToManager: async function (context, data) {
    console.log('s3KeyName', data.s3KeyName)
    try {
      let reqData = {
        send_to: [data.managerEmail],
        template: 'training-account-creation',
        s3KeyName: data.s3KeyName
      }
      console.log('reqData', reqData)
      context.commit('setLoader', { loading: true, text: 'Sending email to manager...' }, { root: true })
      let res = await ApiService.post(process.env.VUE_APP_GALAXY_MAIL_SERVER_API, reqData)
      context.commit('setLoader', { loading: false}, { root: true });
    } catch (error) {
      throw new Error('Error:' + error)
    }
  }
}
